import React from'react';function NewMessageSound(){return/*#__PURE__*/React.createElement(React.Fragment,null);}export default NewMessageSound;